"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../../../common/js/BaseComponent");
var HandleRequest_1 = require("../../../../../common/js/services/requestHttp/HandleRequest");
var updateTemplate_1 = require("../../services/cart/updateTemplate");
var Cart = /** @class */ (function (_super) {
    __extends(Cart, _super);
    function Cart($view) {
        var _this = _super.call(this, $view) || this;
        _this.ADDRESS_TYPE_DELIVERY = 1;
        _this.ADDRESS_TYPE_INVOICE = 2;
        _this.initListeners();
        // @ts-ignore
        _this.initTooltip();
        return _this;
    }
    Cart.prototype.initTooltip = function () {
        /*const tooltip = document.getElementById('paiements_means');
        if (tooltip != null) {
            // @ts-ignore
            new window.bootstrap.Tooltip(tooltip);
        }*/
    };
    Cart.prototype.getInvoiceSelectSelector = function () {
        return '#select-invoice-address';
    };
    Cart.prototype.getPreviousFinalSelector = function () {
        return '#previous-final';
    };
    Cart.prototype.getPreviousAddressSelector = function () {
        return '#previous-address';
    };
    Cart.prototype.getDeliverySelectSelector = function () {
        return '#select-delivery-address';
    };
    Cart.prototype.getUseInvoiceAddressSelector = function () {
        return '#use-invoice-address';
    };
    Cart.prototype.getDeliveryAddressesListSelector = function () {
        return '#delivery-addresses-list';
    };
    Cart.prototype.getShippingMeansSelector = function () {
        return 'delivery-plan';
    };
    Cart.prototype.initListeners = function () {
        var _this = this;
        this.$view.on('change', 'textarea', function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, Cart.updateComment($(e.target))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        this.$view.on('change', 'input', function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, Cart.updateInput($(e.target))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        this.$view.on('click', '.resume-adresses a', function (e) { return __awaiter(_this, void 0, void 0, function () {
            var tab;
            return __generator(this, function (_a) {
                e.preventDefault();
                tab = new bootstrap.Tab(document.querySelector(".step_2"));
                tab.show();
                return [2 /*return*/];
            });
        }); });
        this.$view.on('click', '.delivery-choices .delivery-choice', function (e) { return __awaiter(_this, void 0, void 0, function () {
            var $input;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        $input = $(e.target).parents('.delivery-choice').find('input');
                        return [4 /*yield*/, this.selectDeliveryMean($input)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        this.$view.on('click', '.shops-choices .shops-choice', function (e) { return __awaiter(_this, void 0, void 0, function () {
            var $input;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        $input = $(e.target).parents('.shops-choice').find('input');
                        return [4 /*yield*/, this.selectShopsDelivery($input)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        this.initChangeInvoiceAddress();
        this.initChangeDeliveryAddress();
        this.initSelectInvoiceAsShipping();
        this.initPreviousStep();
    };
    Cart.prototype.initSelectInvoiceAsShipping = function () {
        var _this = this;
        this.$view.on('change', this.getUseInvoiceAddressSelector(), function (e) { return __awaiter(_this, void 0, void 0, function () {
            var list, $el, value;
            return __generator(this, function (_a) {
                list = $(this.getDeliveryAddressesListSelector());
                $el = $(this.getDeliverySelectSelector());
                if (e.target.checked) {
                    value = $(this.getDeliverySelectSelector()).children("option:selected").val();
                    list.removeClass('d-none');
                    this.initChangeSelectedAddress(this.ADDRESS_TYPE_INVOICE, value, $el, false);
                }
                else {
                    list.addClass('d-none');
                    this.initChangeSelectedAddress(this.ADDRESS_TYPE_INVOICE, -1, $el, false);
                }
                return [2 /*return*/];
            });
        }); });
    };
    Cart.prototype.initChangeInvoiceAddress = function () {
        var _this = this;
        this.$view.on('change', this.getInvoiceSelectSelector(), function (e) { return __awaiter(_this, void 0, void 0, function () {
            var $el, value;
            return __generator(this, function (_a) {
                e.preventDefault();
                $el = $(e.target);
                value = $(this.getInvoiceSelectSelector()).children("option:selected").val();
                this.initChangeSelectedAddress(this.ADDRESS_TYPE_INVOICE, value, $el, false);
                return [2 /*return*/];
            });
        }); });
    };
    Cart.prototype.initChangeDeliveryAddress = function () {
        var _this = this;
        this.$view.on('change', this.getDeliverySelectSelector(), function (e) { return __awaiter(_this, void 0, void 0, function () {
            var $el, value, isSameAddress;
            return __generator(this, function (_a) {
                e.preventDefault();
                $el = $(e.target);
                value = $(this.getDeliverySelectSelector()).children("option:selected").val();
                isSameAddress = $(this.getUseInvoiceAddressSelector()).is(':checked');
                this.initChangeSelectedAddress(this.ADDRESS_TYPE_DELIVERY, value, $el, isSameAddress);
                return [2 /*return*/];
            });
        }); });
    };
    Cart.prototype.initChangeSelectedAddress = function (type, value, target, isSameAddress) {
        this.sendAjax(target.data('route_update'), 'POST', {
            'update_cart': true,
            address_id: value,
            type: type,
            isSameAddress: isSameAddress,
            return_templates: [target.data('return_template')],
        });
    };
    Cart.updateComment = function (textarea) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, HandleRequest_1.send)(textarea.data('route_update'), 'PUT', JSON.stringify({
                            update_cart: true,
                            comment: textarea.val(),
                        }))];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Cart.updateInput = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            var nameInput, $data, response, data;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        nameInput = input.attr('name').toString();
                        $data = (_a = {
                                update_cart: true
                            },
                            _a[nameInput] = input.val(),
                            _a);
                        return [4 /*yield*/, (0, HandleRequest_1.send)(input.data('route_update'), 'PUT', JSON.stringify($data))];
                    case 1:
                        response = _b.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.nextStep = function () {
        return __awaiter(this, void 0, void 0, function () {
            var nextStep, link, response, data, tabb, tab;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        nextStep = Cart.currentStep() + 1;
                        link = $('#next_step').data('route_update');
                        return [4 /*yield*/, (0, HandleRequest_1.send)(link, 'PUT', JSON.stringify({
                                update_cart: true,
                                next_step: nextStep,
                                return_templates: ['tab_list'],
                            }))];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        if (data.message) {
                            (0, updateTemplate_1.default)(data);
                        }
                        tabb = document.querySelector(".step_".concat(nextStep));
                        tab = new bootstrap.Tab(tabb);
                        tab.show();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Cart.currentStep = function () {
        return parseInt($('.nav .nav-link.active .step-number').html(), 10);
    };
    Cart.prototype.selectDeliveryMean = function ($input) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.$view.find('.delivery-choices .delivery-choice').each(function () {
                            $(this).find('input').prop('checked', false);
                            $(this).find('.btn-primary').removeClass('d-none');
                        });
                        $input.prop('checked', true);
                        return [4 /*yield*/, (0, HandleRequest_1.send)(this.$view.find('.delivery-choices').data('route_update'), 'PUT', JSON.stringify({
                                update_cart: true,
                                shipping_means: $input.val(),
                                return_templates: [this.$view.find('.delivery-choices').data('return_template')],
                            }))];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        if (data.success) {
                            (0, updateTemplate_1.default)(data);
                            if ($input.attr("name").indexOf("retrait") >= 0) {
                                url = $input.attr('data-url-select-shop');
                                window.HegydCore.initRemoteModal('#select-shop-modal', url, null);
                            }
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Cart.prototype.selectShopsDelivery = function ($input) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.$view.find('.shops-choices .shops-choice').each(function () {
                    $(this).find('input').prop('checked', false);
                    $(this).find('.btn-primary').removeClass('d-none');
                });
                $input.prop('checked', true);
                return [2 /*return*/];
            });
        });
    };
    Cart.prototype.initPreviousStep = function () {
        var _this = this;
        this.$view.on('click', "#previous_step", function (e) { return __awaiter(_this, void 0, void 0, function () {
            var $el, route;
            return __generator(this, function (_a) {
                e.preventDefault();
                $el = $(e.target);
                route = $el.data('route_update');
                window.HegydCore.sendRequest(route, 'PUT', {
                    'update_cart': true,
                    'previous_step': true,
                }, function (data) {
                    window.location.reload();
                });
                return [2 /*return*/];
            });
        }); });
    };
    Cart.prototype.sendAjax = function (url, method, requestData) {
        var _this = this;
        window.HegydCore.sendRequest(url, method, __assign({}, requestData), function (data) {
            // succes
            _this.updateCartViews(data);
        }, function (_a) {
            var responseJSON = _a.responseJSON;
            // echec
        });
    };
    Cart.prototype.updateCartViews = function (data) {
        var update = (0, updateTemplate_1.default)(data);
    };
    return Cart;
}(BaseComponent_1.default));
exports.default = Cart;
